<template>
  <menikheim-layout>
    <template #content>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1><span class="text-highlight">T</span>hird Party Notices</h1>
            <p>Hinweise zu verwendeten Drittanbieter-Lizenzen.</p>
            <p v-if="isLoading">Die Lizenzhinweise werden geladen.</p>
            <p v-else-if="errorMessage">{{ errorMessage }}</p>
            <pre v-else class="third-party-notices">{{ noticeText }}</pre>
          </div>
        </div>
      </div>
    </template>
  </menikheim-layout>
</template>

<script>
import MenikheimLayout from "@/layouts/MenikheimLayout.vue";

export default {
  name: "ThirdPartyNoticesPage",
  components: {
    MenikheimLayout
  },
  data() {
    return {
      noticeText: "",
      errorMessage: "",
      isLoading: true,
    };
  },
  async mounted() {
    try {
      const response = await fetch("/third-party-notices.txt");

      if (!response.ok) {
        throw new Error("Third Party Notices konnten nicht geladen werden.");
      }

      this.noticeText = await response.text();
    } catch (error) {
      this.errorMessage = error.message;
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style scoped>
.third-party-notices {
  background: rgb(var(--color-weiss));
  border-left: 4px solid rgb(var(--color-rot));
  color: rgb(var(--color-grau));
  font-family: inherit;
  font-size: 0.95rem;
  line-height: 1.55;
  max-height: 70vh;
  overflow: auto;
  padding: 1rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
